<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-body">
      <i class="flaticon-cancel-12 close" (click)="cancel()"></i>
      <div class="add-contact-box">
        <div class="add-contact-content">
          <h5 class="text-center mb-4">{{ 'edituser' | translate }}</h5>
          <form style="display: flex; flex-direction: column; gap: 20px">
            <div class="row">
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-name">
                  <i class="las la-user"></i>
                  <input
                    [(ngModel)]="user.name"
                    type="text"
                    name="name"
                    id="c-name"
                    class="form-control"
                    placeholder="Full name"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-name">
                  <i class="las la-user"></i>
                  <input
                    [(ngModel)]="user.userName"
                    (change)="changeUserName()"
                    type="text"
                    name="userName"
                    id="c-name"
                    class="form-control"
                    placeholder="Name"
                    required
                  />
                  <div class="error-field" *ngIf="duplicateUserNameError">
                    <span>{{ 'userNameTaken' | translate }}</span>
                  </div>
                </div>
              </div>
              <div class="col-md-12" style="margin-top: 20px">
                <div class="contact-email">
                  <i class="las la-envelope"></i>
                  <input
                    [(ngModel)]="user.email"
                    (change)="changeEmail()"
                    type="text"
                    name="email"
                    id="c-email"
                    class="form-control"
                    placeholder="Email"
                    required
                  />
                  <div class="error-field" *ngIf="duplicateEmailError">
                    <span>{{ 'emailTaken' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-contact">
                  <i class="las la-phone"></i>
                  <input
                    [(ngModel)]="user.phone"
                    name="contact"
                    type="number"
                    id="c-contact"
                    class="form-control number-input"
                    placeholder="Contact"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="profile"
                    [closeOnSelect]="true"
                    placeholder="Perfil"
                    [(ngModel)]="this.user['idRolUser']"
                    required
                  >
                    <ng-option *ngFor="let role of roles" [value]="role.id">
                      {{ 'roles.' + role.name | translate }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="companies"
                    [items]="companies"
                    bindLabel="name"
                    bindValue="id"
                    (ngModelChange)="companyChanged($event)"
                    [closeOnSelect]="true"
                    placeholder="Compañia"
                    [(ngModel)]="this.user['idCompany']"
                    required
                  ></ng-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="contact-location">
                  <i class="las la-map-marker"></i>
                  <ng-select
                    class="selectpicker"
                    name="departments"
                    [items]="departments"
                    [closeOnSelect]="true"
                    placeholder="Departamento"
                    [(ngModel)]="this.user['department']"
                  ></ng-select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <a class="pointer text-primary font-12 mr-3" (click)="cancel()">{{
        'cancel' | translate
      }}</a>
      <button
        class="btn btn-sm btn-primary"
        (click)="save()"
        *ngIf="!isLoading"
        [disabled]="!canSave"
      >
        <span>
          {{ 'submit' | translate }}
        </span>
      </button>
      <button
        class="btn btn-sm btn-prim btn-loading"
        style="min-width: 140px"
        *ngIf="isLoading"
      >
        <span *ngIf="isLoading" class="loader-btn"></span>
      </button>
    </div>
  </div>
</div>
